<!-- ════ BREADCRUMB ════ -->
<div class="breadcrumb-wrapper">
  <div class="container">
    <p-breadcrumb [model]="items" [home]="home" />
  </div>
</div>

<!-- ════ MAIN CONTAINER ════ -->
<div class="campanha-detalhe-page">
  <div class="container">
    <ng-container *ngIf="loading; else setData">
      <app-skeleton-loader [count]="1" type="detalhe-campanha"></app-skeleton-loader>
    </ng-container>

    <ng-template #setData>
      <ng-container *ngIf="campanha; else Nodata">
        <!-- ════ HEADER BANNER ════ -->
        <header class="detail-header-card">
          <div class="detail-header-top">
            <h1 class="detail-title">{{ campanha?.titulo }}</h1>

            <div class="header-reactions">
              <span class="likes-pill" *ngIf="campanha?.curtidas?.totalCurtidas">
                <i class="fas fa-heart text-red-500 mr-1" *ngIf="campanha?.curtidas?.utilizadorCurtiu"></i>
                <i class="far fa-heart mr-1" *ngIf="!campanha?.curtidas?.utilizadorCurtiu"></i>
                {{ campanha?.curtidas?.totalCurtidas }} apoios
              </span>
            </div>
          </div>

          <div class="badges-row">
            <span class="badge-cat" *ngIf="campanha?.categoria?.descricao">
              <i class="fas fa-tag"></i>
              {{ campanha?.categoria?.descricao }}
            </span>
            <span class="badge-location" *ngIf="campanha?.provincia?.descricao">
              <i class="fas fa-map-marker-alt"></i>
              {{ campanha?.provincia?.descricao }}, Angola
            </span>
            <span class="badge-type" *ngIf="campanha?.tipoFinanciamento">
              <i class="fas fa-hand-holding-dollar"></i>
              {{ campanha?.tipoFinanciamento }}
            </span>
          </div>
        </header>

        <!-- ════ 2-COLUMN LAYOUT ════ -->
        <div class="detail-main-layout">
          <!-- ── LEFT COLUMN: MEDIA & TABS ── -->
          <main class="detail-content-col">
            <!-- Media / Custom Video Player -->
            <div class="media-gallery-card custom-player-wrapper" (mouseenter)="showOverlay()"
              (mouseleave)="hideOverlay()" (mousemove)="resetOverlayTimeout()">
              <ng-container *ngIf="videoPreview; else showLinkVideo">
                <video #nativeVideo [src]="videoPreview" [muted]="isMuted" class="media-element"
                  (timeupdate)="onNativeTimeUpdate()" (loadedmetadata)="onNativeLoadedMetadata()"
                  (play)="onNativePlayStateChange(true)" (pause)="onNativePlayStateChange(false)"></video>
              </ng-container>

              <ng-template #showLinkVideo>
                <ng-container *ngIf="videoLink; else showImage">
                  <iframe #youtubePlayerIframe id="yt-player" [src]="videoLink | safeUrl" frameborder="0"
                    class="media-element iframe-element" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </ng-container>
              </ng-template>

              <ng-template #showImage>
                <img [src]="imgPreview || '/images/campanha-1.png'" [alt]="campanha?.titulo || 'Imagem da campanha'"
                  class="media-element" />
              </ng-template>

              <!-- Video Custom Controls Overlay -->
              <div *ngIf="videoPreview || videoLink" class="video-controls-overlay"
                [class.visible]="isOverlayVisible || !isPlaying" (click)="onOverlayClick($event)">
                <div class="video-header">
                  <h4 class="video-title">{{ campanha?.titulo || 'Vídeo de Apresentação' }}</h4>
                </div>

                <div class="video-center-btn">
                  <button type="button" class="play-pause-btn" (click)="togglePlay(); $event.stopPropagation()">
                    <i [class]="isPlaying ? 'fas fa-pause' : 'fas fa-play'"></i>
                  </button>
                </div>

                <div class="video-footer">
                  <div class="progress-container" (click)="seekVideo($event)">
                    <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
                  </div>
                  <div class="controls-row">
                    <div class="time-display">
                      <span>{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
                    </div>
                    <div class="volume-container" (click)="$event.stopPropagation()">
                      <button type="button" class="volume-btn" (click)="toggleMute()">
                        <i
                          [class]="isMuted ? 'fas fa-volume-xmark' : (volume > 50 ? 'fas fa-volume-high' : 'fas fa-volume-low')"></i>
                      </button>
                      <div class="volume-slider-wrapper">
                        <input type="range" min="0" max="100" [value]="isMuted ? 0 : volume"
                          (input)="onVolumeChange($event)" class="volume-slider" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabs Navigation -->
            <div class="detail-tabs-wrapper">
              <nav class="tabs-nav-bar">
                <button type="button" class="tab-nav-btn" [class.active]="TabIndex === 0" (click)="ativateTab(0)">
                  <i class="fas fa-file-lines"></i>
                  <span>Detalhes</span>
                </button>
                <button type="button" class="tab-nav-btn" [class.active]="TabIndex === 1" (click)="ativateTab(1)">
                  <i class="fas fa-paperclip"></i>
                  <span>Documentos</span>
                </button>
                <button type="button" class="tab-nav-btn" [class.active]="TabIndex === 2" (click)="ativateTab(2)">
                  <i class="fas fa-comments"></i>
                  <span>Comentários</span>
                </button>
                <button type="button" class="tab-nav-btn" [class.active]="TabIndex === 3" (click)="ativateTab(3)">
                  <i class="fas fa-hand-holding-heart"></i>
                  <span>Apoiadores e Doações</span>
                </button>
                <button *ngIf="isCampanhaRecompensa()" type="button" class="tab-nav-btn" [class.active]="TabIndex === 4" (click)="ativateTab(4)">
                  <i class="fas fa-gift"></i>
                  <span>Recompensas ({{ campanha?.recompensa?.length || 0 }})</span>
                </button>
              </nav>

              <!-- Tab Contents -->
              <div class="tab-panel-container">
                <!-- Tab 0: Story / Details -->
                <div class="tab-panel" *ngIf="TabIndex === 0">
                  <div class="story-content-section">
                    <h3 class="panel-heading">Sobre Esta Campanha</h3>
                    <p class="story-lead">{{ campanha?.descricaoCurta }}</p>
                    <div class="story-body" [innerHTML]="campanha?.descricao || 'Sem descrição completa informada.'">
                    </div>

                    <!-- Social Links if available -->
                    <div class="social-links-block" *ngIf="campanha?.redesSociaisList?.length">
                      <h4 class="social-links-heading">Canais e Redes do Projecto</h4>
                      <div class="social-links-list">
                        <a *ngFor="let url of campanha?.redesSociaisList" [href]="url" target="_blank" rel="noopener"
                          class="social-link-item">
                          <i [class]="url | socialIcon"></i>
                          <span>{{ url | trimText: 40 }}</span>
                          <i class="fas fa-arrow-up-right-from-square ml-auto text-xs"></i>
                        </a>
                      </div>
                    </div>

                    <!-- Bloco de Recompensas na História -->
                    <div class="rewards-story-block" *ngIf="isCampanhaRecompensa() && campanha?.recompensa?.length">
                      <div class="rsb-header">
                        <div class="rsb-title-group">
                          <i class="fas fa-gift text-primary"></i>
                          <h4>Recompensas para Apoiadores</h4>
                        </div>
                        <span class="rsb-badge">{{ campanha.recompensa.length }} {{ campanha.recompensa.length === 1 ? 'recompensa disponível' : 'recompensas disponíveis' }}</span>
                      </div>
                      <div class="rewards-grid">
                        <div class="reward-card" *ngFor="let rec of campanha.recompensa; let i = index">
                          <div class="rc-header">
                            <span class="rc-tier">#{{ i + 1 }}</span>
                            <span class="rc-type" *ngIf="rec.tipoRecompensa">
                              <i class="fas fa-cube mr-1"></i>{{ rec.tipoRecompensa }}
                            </span>
                          </div>
                          <h4 class="rc-title">{{ rec.titulo }}</h4>
                          <div class="rc-value">{{ rec.valor | money }} Kz</div>
                          <p class="rc-desc">{{ rec.descricao }}</p>
                          <div class="rc-meta-info">
                            <div class="rc-meta-item">
                              <i class="fas fa-boxes-stacked"></i>
                              <span>Disponibilidade: <strong>{{ rec.quantidadeDisponivel ?? rec.quantidade }} de {{ rec.quantidade }}</strong></span>
                            </div>
                            <div class="rc-meta-item" *ngIf="rec.dataIncioRecompensa || rec.dataInicioRecompensa">
                              <i class="fas fa-calendar-alt"></i>
                              <span>Vigência: {{ (rec.dataIncioRecompensaFormatada || rec.dataIncioRecompensa || rec.dataInicioRecompensa) | date: 'dd/MM/yyyy' }} a {{ (rec.dataTerminoRecompensaFormatada || rec.dataTerminoRecompensa) | date: 'dd/MM/yyyy' }}</span>
                            </div>
                          </div>
                          <button type="button" class="btn-reward-cta" (click)="callRouteFinacy(campanha?.id, $event, rec.id)"
                            *ngIf="campanha?.estadoCampanhaENUM === 4 || campanha?.EstadoCampanhaENUM === 4 || campanha?.estado === 'Publicada' || campanha?.estado === 'Em Andamento'">
                            <i class="fas fa-hand-holding-dollar mr-1"></i>
                            <span>Apoiar com esta Recompensa</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Tab 1: Documents & Attachments -->
                <div class="tab-panel" *ngIf="TabIndex === 1">
                  <h3 class="panel-heading">Documentos e Anexos Oficiais</h3>
                  <ng-container *ngIf="imgPreview || docPreview; else NoFiles">
                    <div class="attachments-grid">
                      <!-- PDF Document -->
                      <div class="attachment-card" *ngIf="docPreview && docInfo" (click)="abrirDoc($event)"
                        role="button" tabindex="0" (keydown.enter)="abrirDoc($event)" title="Visualizar Documento">
                        <div class="attachment-icon pdf">
                          <i class="fas fa-file-pdf"></i>
                        </div>
                        <div class="attachment-info">
                          <h5 class="attachment-name">{{ docInfo.nome }}</h5>
                          <span class="attachment-meta">
                            {{ docInfo.tamanho }} · {{ docInfo.tipo }}
                          </span>
                        </div>
                        <div class="attachment-action" title="Visualizar Documento">
                          <i class="fas fa-eye"></i>
                        </div>
                      </div>

                      <!-- Image Asset -->
                      <div class="attachment-card" *ngIf="imgPreview && imgInfo" (click)="abrirImagem($event)"
                        role="button" tabindex="0" (keydown.enter)="abrirImagem($event)" title="Visualizar Imagem">
                        <div class="attachment-icon image">
                          <i class="fas fa-file-image"></i>
                        </div>
                        <div class="attachment-info">
                          <h5 class="attachment-name">{{ imgInfo.nome }}</h5>
                          <span class="attachment-meta">
                            {{ imgInfo.tamanho }} · {{ imgInfo.tipo }}
                          </span>
                        </div>
                        <div class="attachment-action" title="Visualizar Imagem">
                          <i class="fas fa-eye"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #NoFiles>
                    <div class="nodata-box">
                      <app-data-void titulo="Sem documentos anexados"
                        descricao="Esta campanha não disponibilizou anexos ou apresentações em PDF."></app-data-void>
                    </div>
                  </ng-template>
                </div>

                <!-- Tab 2: Comments -->
                <div class="tab-panel" id="tab-comentarios" *ngIf="TabIndex === 2">
                  <app-lista-comentarios [comments]="comentarios" [campanhaID]="campanhaID"
                    (commentChanged)="onCommentAdded()"></app-lista-comentarios>
                </div>

                <!-- Tab 3: Backers & Donations -->
                <div class="tab-panel" *ngIf="TabIndex === 3">
                  <app-lista-pagamentos [campanhaID]="campanhaID"></app-lista-pagamentos>
                </div>

                <!-- Tab 4: Recompensas da Campanha -->
                <div class="tab-panel" *ngIf="TabIndex === 4">
                  <div class="tab-rewards-section">
                    <div class="trs-header">
                      <div>
                        <h3 class="panel-heading mb-1">Recompensas para os Apoiadores</h3>
                        <p class="text-sm text-gray-500">Escolha uma das recompensas preparadas pelo criador para apoiar este projecto.</p>
                      </div>
                      <div class="trs-total-badge">
                        <i class="fas fa-gift text-primary mr-1"></i>
                        <span>{{ campanha?.recompensa?.length || 0 }} Recompensas</span>
                      </div>
                    </div>

                    <div class="rewards-grid mt-4">
                      <div class="reward-card" *ngFor="let rec of campanha?.recompensa; let i = index">
                        <div class="rc-header">
                          <span class="rc-tier">#{{ i + 1 }}</span>
                          <span class="rc-type" *ngIf="rec.tipoRecompensa">
                            <i class="fas fa-cube mr-1"></i>{{ rec.tipoRecompensa }}
                          </span>
                        </div>
                        <h4 class="rc-title">{{ rec.titulo }}</h4>
                        <div class="rc-value">{{ rec.valor | money }} Kz</div>
                        <p class="rc-desc">{{ rec.descricao }}</p>
                        <div class="rc-meta-info">
                          <div class="rc-meta-item">
                            <i class="fas fa-boxes-stacked"></i>
                            <span>Disponibilidade: <strong>{{ rec.quantidadeDisponivel ?? rec.quantidade }} de {{ rec.quantidade }}</strong></span>
                          </div>
                          <div class="rc-meta-item" *ngIf="rec.dataIncioRecompensa || rec.dataInicioRecompensa">
                            <i class="fas fa-calendar-alt"></i>
                            <span>Vigência: {{ (rec.dataIncioRecompensaFormatada || rec.dataIncioRecompensa || rec.dataInicioRecompensa) | date: 'dd/MM/yyyy' }} a {{ (rec.dataTerminoRecompensaFormatada || rec.dataTerminoRecompensa) | date: 'dd/MM/yyyy' }}</span>
                          </div>
                        </div>
                        <button type="button" class="btn-reward-cta" (click)="callRouteFinacy(campanha?.id, $event, rec.id)"
                          *ngIf="campanha?.estadoCampanhaENUM === 4 || campanha?.EstadoCampanhaENUM === 4 || campanha?.estado === 'Publicada' || campanha?.estado === 'Em Andamento'">
                          <i class="fas fa-hand-holding-dollar mr-1"></i>
                          <span>Apoiar com esta Recompensa</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <!-- ── RIGHT COLUMN: STICKY FUNDING SIDEBAR ── -->
          <aside class="detail-sidebar-col">
            <div class="sidebar-sticky-wrapper">
              <!-- Main Funding Box -->
              <div class="funding-box-card">
                <div class="funding-card-header">
                  <div class="funding-label-top">Total Arrecadado</div>
                  <div class="funding-main-amount">
                    {{ (campanha?.valorArrecado || 0) | money }} Kz
                  </div>
                  <div class="funding-target-label">
                    da meta estabelecida de <strong>{{ (campanha?.metaArrecadar || 0) | money }} Kz</strong>
                  </div>
                </div>

                <div class="funding-card-body">
                  <!-- Shimmer Progress Bar -->
                  <div class="funding-progress-section">
                    <div class="fp-header">
                      <span class="fp-pct">{{ getPercent(campanha) }}%</span>
                      <span class="fp-badge" [ngClass]="getPctClass(getPercent(campanha))">
                        {{ campanha?.estado }}
                      </span>
                    </div>

                    <div class="fp-track">
                      <div class="fp-fill" [ngClass]="getPctClass(getPercent(campanha))"
                        [style.width.%]="getPercent(campanha) > 100 ? 100 : getPercent(campanha)"></div>
                    </div>
                  </div>

                  <!-- Quick Stats Grid -->
                  <div class="funding-stats-grid">
                    <div class="fstat-box">
                      <div class="fstat-value">
                        <i class="fas fa-users text-blue-500 mr-1 text-sm"></i>
                        {{ campanha?.totalApoiantes || 0 }}
                      </div>
                      <div class="fstat-label">Apoiadores</div>
                    </div>

                    <div class="fstat-box">
                      <div class="fstat-value" [class.text-red-500]="(campanha?.diasRestantes || 0) <= 7">
                        <i class="fas fa-clock text-amber-500 mr-1 text-sm"></i>
                        {{ campanha?.diasRestantes || 0 }}
                      </div>
                      <div class="fstat-label">Dias Restantes</div>
                    </div>

                    <div class="fstat-box">
                      <div class="fstat-value">
                        <i class="fas fa-map-marker-alt text-green-600 mr-1 text-sm"></i>
                        {{ campanha?.provincia?.descricao || 'Angola' }}
                      </div>
                      <div class="fstat-label">Província</div>
                    </div>

                    <div class="fstat-box">
                      <div class="fstat-value">
                        <i class="fas fa-shield-halved text-purple-600 mr-1 text-sm"></i>
                        {{ campanha?.estado}}
                      </div>
                      <div class="fstat-label">Estado</div>
                    </div>
                  </div>

                  <!-- Funding CTA Button -->
                  <div class="funding-cta-container">
                    <button type="button" class="btn-fund-main" (click)="callRouteFinacy(campanha?.id, $event)"
                      *ngIf="campanha?.estadoCampanhaENUM === 4 || campanha?.EstadoCampanhaENUM === 4 || campanha?.estado === 'Publicada' || campanha?.estado === 'Em Andamento'">
                      <i class="fas fa-heart"></i>
                      <span>Financiar Este Projecto</span>
                    </button>

                    <div class="campaign-closed-alert"
                      *ngIf="campanha?.estadoCampanhaENUM !== 4 && campanha?.EstadoCampanhaENUM !== 4 && campanha?.estado !== 'Publicada' && campanha?.estado !== 'Em Andamento'">
                      <i class="fas fa-lock mr-2"></i>
                      <span>Esta campanha encontra-se encerrada para novas contribuições.</span>
                    </div>
                  </div>

                  <!-- Reactions -->
                  <div class="sidebar-reactions">
                    <app-reactions [campanhaID]="campanha?.id" [curtidaID]="campanha?.curtidas?.curtidasId"
                      [totalCurtidas]="campanha?.curtidas?.totalCurtidas || 0"
                      [totalComentarios]="campanha?.totalComentarios || 0" [(showComment)]="showSidebarComment"
                      (commentAdded)="onCommentAdded()" (commentClicked)="onCommentClicked()"></app-reactions>
                  </div>

                  <!-- Trust & Security -->
                  <div class="funding-trust-footer">
                    <div class="trust-item">
                      <i class="fas fa-shield-alt text-green-600"></i>
                      <span>Pagamentos 100% seguros</span>
                    </div>
                    <div class="trust-item">
                      <i class="fas fa-check-double text-primary"></i>
                      <span>Multicaixa Express / GPO / Transferência</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sidebar Rewards List -->
              <div class="sidebar-rewards-box" *ngIf="isCampanhaRecompensa() && campanha?.recompensa?.length">
                <div class="srb-header">
                  <div class="srb-title">
                    <i class="fas fa-gift text-primary"></i>
                    <span>Recompensas</span>
                  </div>
                  <span class="srb-count">{{ campanha.recompensa.length }}</span>
                </div>
                <div class="srb-list">
                  <div class="srb-item" *ngFor="let rec of campanha.recompensa">
                    <div class="srb-item-top">
                      <span class="srb-val">{{ rec.valor | money }} Kz</span>
                      <span class="srb-badge" *ngIf="rec.tipoRecompensa">{{ rec.tipoRecompensa }}</span>
                    </div>
                    <div class="srb-item-title">{{ rec.titulo }}</div>
                    <p class="srb-item-desc">{{ rec.descricao }}</p>
                    <div class="srb-item-meta">
                      <span><i class="fas fa-box-open mr-1"></i>{{ rec.quantidadeDisponivel ?? rec.quantidade }} de {{ rec.quantidade }} un.</span>
                    </div>
                    <button type="button" class="srb-item-btn" (click)="callRouteFinacy(campanha?.id, $event, rec.id)"
                      *ngIf="campanha?.estadoCampanhaENUM === 4 || campanha?.EstadoCampanhaENUM === 4 || campanha?.estado === 'Publicada' || campanha?.estado === 'Em Andamento'">
                      <span>Apoiar</span>
                      <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Creator Card -->
              <div class="creator-card">
                <div class="creator-card-header">Sobre o Criador</div>
                <div class="creator-card-body">
                  <div class="creator-profile-row">
                    <div class="creator-avatar-lg">
                      {{ (campanha?.utilizadorNome ? campanha?.utilizadorNome[0] : 'U') | uppercase }}
                    </div>
                    <div>
                      <h4 class="creator-card-name">{{ campanha?.utilizadorNome || "Autor da Campanha" }}</h4>
                      <span class="creator-card-tag">
                        <i class="fas fa-circle-check text-green-600"></i> Identidade Confirmada
                      </span>
                    </div>
                  </div>
                  <p class="creator-card-bio">
                    Projecto sediado em {{ campanha?.provincia?.descricao || 'Luanda, Angola' }}. Verificado pela equipa
                    de auditoria da FundCube.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #Nodata>
      <div class="p-6">
        <app-data-void titulo="Campanha não encontrada"
          descricao="Esta campanha pode ter sido removida ou não está disponível publicamente."></app-data-void>
      </div>
    </ng-template>
  </div>
</div>

<!-- Modal Documento PDF -->
<p-dialog [header]="docInfo?.nome || 'Documento da Campanha'" [(visible)]="showDocModal" [modal]="true"
  [dismissableMask]="true" [style]="{ width: '85vw', maxWidth: '1200px', height: '90vh' }"
  [contentStyle]="{ height: 'calc(90vh - 75px)', padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container">
    <div class="modal-viewer-toolbar">
      <div class="toolbar-info">
        <i class="fas fa-file-pdf text-red-500 mr-2"></i>
        <span>{{ docInfo?.nome }} ({{ docInfo?.tamanho }})</span>
      </div>
      <div class="toolbar-actions">
        <button type="button" class="btn-toolbar" (click)="descarregarFicheiro(docRawUrl, docInfo?.nome, $event)">
          <i class="fas fa-download"></i> Descarregar
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(docRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Abrir em Nova Aba
        </button>
      </div>
    </div>
    <iframe *ngIf="docPreview" [src]="docPreview" class="modal-iframe-viewer" frameborder="0"></iframe>
  </div>
</p-dialog>

<!-- Modal Imagem -->
<p-dialog [header]="imgInfo?.nome || 'Imagem da Campanha'" [(visible)]="showImageModal" [modal]="true"
  [dismissableMask]="true" [style]="{ width: '70vw', maxWidth: '900px' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }">
  <div class="modal-viewer-container image-viewer">
    <div class="modal-viewer-toolbar">
      <div class="toolbar-info">
        <i class="fas fa-file-image text-blue-500 mr-2"></i>
        <span>{{ imgInfo?.nome }} ({{ imgInfo?.tamanho }})</span>
      </div>
      <div class="toolbar-actions">
        <button type="button" class="btn-toolbar" (click)="descarregarFicheiro(imgRawUrl, imgInfo?.nome, $event)">
          <i class="fas fa-download"></i> Descarregar
        </button>
        <button type="button" class="btn-toolbar" (click)="abrirNovaAba(imgRawUrl, $event)">
          <i class="fas fa-arrow-up-right-from-square"></i> Abrir em Nova Aba
        </button>
      </div>
    </div>
    <div class="modal-img-wrap">
      <img *ngIf="imgPreview" [src]="imgPreview" [alt]="imgInfo?.nome || 'Imagem anexada'" class="modal-full-img" />
    </div>
  </div>
</p-dialog>